<template>
  <modal
    :name="`${id}`"
    height="auto"
    :adaptive="true"
    :scrollable="true"
    :click-to-close="clickToClose"
    @before-open="beforeOpened"
    @before-close="beforeClosed"
    @opened="isModalOn"
    @closed="onClosed"
  >
    <div class="modal custom-modal is-active">
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">
            {{ title }}
          </p>
          <button
            class="delete"
            aria-label="close"
            @click="$modal.hide(id);"
          />
        </header>
        <section class="modal-card-body content p-md">
          <slot v-if="!text" />
          <p
            v-else
            v-html="text"
          />
        </section>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      default: () => `tx_${Math.random().toString(12).substring(2, 8)}`,
    },
    title: {
      type: String,
      default: 'Help.',
    },
    text: {
      type: String,
      default: null,
      required: false,
    },
    visible: {
      type: Boolean,
      required: false,
      default: false,
    },
    clickToClose: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      params: {},
    };
  },
  watch: {
    visible(newValue) {
      this.checkVisible(newValue);
    },
  },
  mounted() {
    this.checkVisible(this.visible);
  },
  methods: {
    beforeOpened ($event) {
      this.params = $event.params || {};
      this.$emit('before-opened', $event);
    },
    beforeClosed ($event) {
      this.$emit('before-closed', $event);
    },
    onClosed($event) {
      if (typeof this.params.onClosed === 'function') {
        this.params.onClosed($event);
      }
      this.params = {};
      this.isModalOff($event);
    },
    checkVisible(newValue) {
      if (newValue) {
        this.show();
      } else {
        this.hide();
      }
    },
    show() {
      this.$modal.show(this.id);
    },
    hide() {
      this.$modal.hide(this.id);
    },
  },
};
</script>

<style>

</style>